import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// 🔹 Gera o link para o portal de faturamento do Stripe
export function getBillingPortalLink() {
  return axios
    .post(`${API_URL}/stripe/billing-portal`, {}, { withCredentials: true })
    .then((response) => response.data)
    .catch((error) => {
      const errorMessage =
        error.response?.data?.error ||
        "Erro ao obter o link do portal de faturamento.";
      throw new Error(errorMessage);
    });
}
